export default __webpack_public_path__ + "static/video-4-588cb73ea5e2b5d28863217f2e8f870a.png";